import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { layout } from 'styled-system';
import { Box } from '@design-system/box';
import { responsive, useTheme } from '@design-system/theme';
export const Picture = ({ coverPictureUrls, showContent = false, }) => {
    const theme = useTheme();
    return (_jsx(PictureRoot, { "$showContent": showContent, dataTestId: "appheader-picture", flexDirection: "column", children: _jsxs("picture", { children: [_jsx("source", { media: `(min-width: ${theme.breakpoints['xl']})`, srcSet: coverPictureUrls.xl }), _jsx("source", { media: `(min-width: ${theme.breakpoints['l']})`, srcSet: coverPictureUrls.l }), _jsx("source", { media: `(min-width: ${theme.breakpoints['m']})`, srcSet: coverPictureUrls.m }), _jsx("source", { media: "(min-width: 0px)", srcSet: coverPictureUrls.s }), _jsx(StaticCoverPicture, { "$showContent": showContent, alt: "", "data-testid": "appheader-cover-picture", src: coverPictureUrls.xl })] }) }));
};
const PictureRoot = styled(Box).attrs(({ $showContent }) => ({
    alignSelf: $showContent ? { m: 'flex-start' } : undefined,
    justifyContent: { s: 'end', m: 'center', l: 'end', xl: 'end' },
    minWidth: {
        l: 470,
        m: 290,
        xl: 676,
    },
    ml: $showContent
        ? {
            l: 6,
            m: 5,
        }
        : 0,
})) ``;
const StaticCoverPicture = styled.img.attrs(({ $showContent }) => ({
    height: {
        l: $showContent ? 216 : 260,
        m: $showContent ? 187 : 196,
        xl: $showContent ? 310 : 374,
    },
    width: $showContent
        ? {
            s: '100%',
            l: 470,
            m: 290,
            xl: 676,
        }
        : '100%',
})) `
  ${layout}
  object-fit: cover;
  ${({ theme }) => {
    const radius = `${theme.themeVariables.globalBorderRadius}px`;
    return responsive('m') `
      border-radius: ${radius};
    `;
}}
`;
//# sourceMappingURL=Picture.js.map